<template>
  <MdApp>
    <MdAppToolbar class="md-primary" md-elevation="1">
      <h3 class="md-title">
        <RouterLink to="/">
          <img src="/images/iguide-logo.svg" class="logo" alt="iGUIDE" />
          <span class="title">Virtual Showing</span>
        </RouterLink>
      </h3>
    </MdAppToolbar>

    <MdAppContent class="md-layout md-alignment-center-center">
      <form novalidate @submit.prevent="createShowing">
        <strong>To get started:</strong>
        <ol style="text-align: left;">
          <li>Enter the iGUIDE URL for the property you would like to show.</li>
          <li>Click the <strong>Create Virtual Showing</strong> button. You will be taken to the virtual showing.</li>
          <li>Click the Share button in the newly created iGUIDE Virtual Showing.</li>
          <li>Copy and paste the URL in an email or chat and send to anyone you would like to view the showing. Remember that you can send the link to as many people as you like.</li>
        </ol>

        <MdField :class="errorClass">
          <label>iGUIDE URL</label>
          <MdInput
            v-model="iguideUrl"
            placeholder="https://youriguide.com/example"
            md-clearable
            required
          />
          <span v-if="!valid" class="md-helper-text">URL is not valid</span>
        </MdField>

        <MdButton class="md-raised md-primary" @click="createShowing">
          Start Virtual Showing
        </MdButton>
      </form>
    </MdAppContent>
  </MdApp>
</template>

<script>
import { db, ServerValue, analytics } from '../firebase';
import { ref, push, set } from 'firebase/database';
import { logEvent } from 'firebase/analytics';

const validHosts = [
  'www.youriguide.com',
  'youriguide.com',
  'unbranded.youriguide.com',
  'www.iguideradix.com',
  'iguideradix.com',
  'unbranded.iguideradix.com',
  'www.iguide.au',
  'iguide.au',
  'localhost:9050',
];

export default {
  props: {
    url: { type: String, default: '' },
  },

  data() {
    return {
      iguideUrl: this.url,
      showErrors: false,
    };
  },

  computed: {
    valid() {
      if (!this.iguideUrl) {
        return true;
      }
      try {
        const u = new URL(this.iguideUrl);
        return validHosts.includes(u.host) && u.pathname.length > 5;
      } catch (e) {
        return false;
      }
    },

    errorClass() {
      return { 'md-invalid': this.showErrors && !this.valid };
    },
  },

  beforeMount() {
    if (this.$root.$route.query.url) {
      const queryUrl = this.$root.$route.query.url;
      if (queryUrl.includes('http://') || queryUrl.includes('https://')) {
        this.iguideUrl = queryUrl;
      } else {
        const id = [...validHosts, 'http://', 'https://'].reduce((result, str) => result.replace(str, ''), queryUrl);
        this.iguideUrl = `https://youriguide.com/${id[0] == '/' ? id.substr(1) : id}`;
      }
    }
  },

  methods: {
    async createShowing() {
      const { iguideUrl, valid } = this;
      if (!iguideUrl || !valid) {
        this.showErrors = !valid;
        return;
      }

      try {
        const r = ref(db, 'showings');
        const showingsRef = push(r);
        await set(showingsRef, {
          createdAt: ServerValue.TIMESTAMP,
          ownerUid: this.$root.$data.user.uid,
          hostUid: this.$root.$data.user.uid,
          iguideUrl,
        });
        
        logEvent(analytics, 'showing_created', { id: showingsRef.key, iguide: iguideUrl });
        await this.$router.replace({ path: `/${showingsRef.key.slice(1)}` });
      } catch (err) {
        console.error('Error creating showing:', err);
        this.showErrors = true;
      }
    },
  },
};
</script>

<style>
form {
  width: 100%;
  max-width: 550px;
}

.md-toolbar h3.md-title {
  font-weight: 700;
  letter-spacing: initial;
}
</style>
